<template>
  <el-dialog
    :title="(Type == 'Create' ? '发布' : '管理') + '现货出售'"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="1000px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-position="top"
    >
      <AlertTip v-if="DialogFormData.status == 0" title="审核中，请耐心等待" />
      <AlertTip
        v-if="DialogFormData.status == -1"
        type="danger"
        :title="l('已下架') + '：'"
        :description="DialogFormData.invalid_reason"
      />

      <div class="FormSubTitle">{{ l("基本信息") }}</div>

      <el-row :gutter="20">
        <el-col key="character" :span="12">
          <el-form-item label="品质" prop="character">
            <el-radio
              v-for="item in $store.state.basicInfo.characterList"
              :key="item.id"
              v-model="DialogFormData.character"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col key="category_id" :span="12">
          <el-form-item :label="l('品类')" prop="category_id">
            <el-select
              v-model="DialogFormData.category_id"
              :disabled="Type != 'Create'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.categoryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col key="child_category" :span="12">
          <el-form-item
            :label="l('品名')"
            prop="child_category"
            style="position: relative"
          >
            <span slot="label">
              <span>{{ l("品名") }}</span>
              <span v-show="Type == 'Create'" class="label_tip">
                <span
                  v-show="select_child_category"
                  @click="
                    select_child_category = false;
                    $nextTick(() => $refs.child_category_input.focus());
                  "
                  >{{ l("点击输入自定义品名") }}</span
                >
                <span
                  v-show="!select_child_category"
                  @click="select_child_category = true"
                  >{{ l("点击使用系统预设品名") }}</span
                >
              </span>
            </span>
            <el-select
              v-if="select_child_category"
              key="child_category_select"
              v-model="DialogFormData.child_category"
              :disabled="Type != 'Create'"
              no-data-text="请先选择品类"
            >
              <el-option
                v-for="item in child_categoryList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <el-input
              v-else
              key="child_category_input"
              ref="child_category_input"
              v-model="DialogFormData.child_category"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col key="material" :span="12">
          <el-form-item
            :label="l('材料')"
            prop="material"
            style="position: relative"
          >
            <span slot="label">
              <span>{{ l("材料") }}</span>
              <span v-show="Type == 'Create'" class="label_tip">
                <span
                  v-show="select_material"
                  @click="
                    select_material = false;
                    $nextTick(() => $refs.material_input.focus());
                  "
                  >{{ l("点击输入自定义材料") }}</span
                >
                <span v-show="!select_material" @click="select_material = true"
                  >点击使用系统预设材料</span
                >
              </span>
            </span>
            <el-select
              v-if="select_material"
              key="material_select"
              v-model="DialogFormData.material"
              :disabled="Type != 'Create'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.materialList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <el-input
              v-else
              key="material_input"
              ref="material_input"
              v-model="DialogFormData.material"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="l('规格')" prop="specification">
            <el-input
              v-model="DialogFormData.specification"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="价格" prop="price">
            <el-row>
              <el-col :span="16">
                <el-input
                  v-model="DialogFormData.price"
                  placeholder="价格"
                  :disabled="Type == 'View'"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="DialogFormData.unit"
                  :disabled="Type == 'View'"
                >
                  <el-option
                    v-for="item in $store.state.basicInfo.unitList"
                    :key="item"
                    :label="'元 / ' + item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="l('钢厂')" prop="steel_mill">
            <el-input
              v-model="DialogFormData.steel_mill"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <ResourceListUpLoad
            label="商品图片"
            prop="img_array"
            usage="quotation"
            :initResourceUrl.sync="DialogFormData.img_array"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>

      <div class="FormSubTitle">其他信息</div>

      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="l('计重方式')" prop="weight_method">
            <el-radio
              v-for="item in $store.state.basicInfo.weight_methodList"
              :key="item.id"
              v-model="DialogFormData.weight_method"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="提供质保书" prop="have_warranty">
            <el-radio
              v-for="item in $store.state.basicInfo.have_warrantyList"
              :key="item.id"
              v-model="DialogFormData.have_warranty"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="发货地" prop="address">
            <el-cascader
              v-model="DialogFormData.address"
              :options="$store.state.basicInfo.cityList"
              :props="{
                expandTrigger: 'hover',
                label: 'name',
                value: 'name',
                children: 'child',
                emitPath: true,
              }"
              clearable
              :disabled="Type == 'View'"
            ></el-cascader>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item :label="l('补充说明')" prop="description">
            <el-input
              type="textarea"
              :rows="5"
              v-model="DialogFormData.description"
              placeholder="您可以填写更多补充说明，如起订数量、加工工艺等"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button
        v-if="
          Type == 'View' &&
          $store.getters.checkPermission('seller_quotation.edit')
        "
        type="warning"
        @click="Type = 'Edit'"
        >{{ l("修 改") }}</el-button
      >
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{ l("保 存") }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditSellerQuotation",
  components: {},
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        code: null,
        status: null,

        title: "",
        quality_type: 1,
        character: 1,
        category_id: null,
        child_category: null,
        material: "",
        specification: "", //来自specification_amount:"",
        price: "", //来自specification_amount:"",
        unit: this.l("吨"), //来自specification_amount:"",
        weight_method: 1,
        have_warranty: 1,
        have_report: 1,
        steel_mill: "",
        address: "",
        img_array: [], //来自img_array:""
        description: "",
        extra_params: "", //暂时用不到
      },
      dialogRules: {
        title: [
          {
            required: true,
            message: this.l("请输入") + this.l("名称"),
            trigger: "change",
          },
        ],
        category_id: [
          {
            required: true,
            type: "number",
            message: this.l("请选择") + this.l("品类"),
            trigger: "change",
          },
        ],
        child_category: [
          {
            required: true,
            message: this.l("请输入") + this.l("品名"),
            trigger: "change",
          },
        ],
        material: [
          {
            required: true,
            message: this.l("请输入") + this.l("材料"),
            trigger: "change",
          },
        ],
        specification: [
          {
            required: true,
            message: this.l("请输入") + this.l("规格"),
            trigger: "change",
          },
        ],
        price: [
          {
            required: true,
            message: this.l("请输入") + this.l("价格"),
            trigger: "change",
          },
        ],
        steel_mill: [
          {
            required: true,
            message: this.l("请输入") + this.l("钢厂"),
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: this.l("请选择") + this.l("发货地"),
            trigger: "change",
          },
        ],
        // img_array: [
        //   { required: false, message: "请上传商品图片", trigger: "change" },
        // ],
      },
      select_child_category: true,
      select_material: true,
    };
  },
  computed: {
    child_categoryList() {
      var category = this.$store.state.basicInfo.categoryList.find(
        (item) => item.id == this.DialogFormData.category_id
      );
      if (category) {
        return category.child.map((item) => item.name);
      } else {
        return [];
      }
    },
  },
  watch: {},
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        if (this.Type == "Create") {
          //先检查还有没有发布资格
          this.axios
            .get(`/api/seller_quotation/check_user_chance/`)
            .then(() => {
              resolve();
            })
            .catch(() => {
              this.Hide();
              reject();
            });
        } else if (this.Type == "View") {
          this.axios
            .get(`/api/seller_quotation/${this.DialogFormData.code}/`)
            .then((response) => {
              response.img_array = JSON.parse(response.img_array);
              response.address = response.address.split("/");
              response.specification =
                response.specification_amount[0].specification;
              response.price = response.specification_amount[0].price;
              response.unit = response.specification_amount[0].unit;
              this.DialogFormData = response;
              resolve();
            })
            .catch(() => {
              reject();
            });
        }
      });
    },
    AfterShow() {},
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        // var title = `${this.DialogFormData.child_category} ${this.DialogFormData.material} ${this.DialogFormData.specification}`;
        var img_array = JSON.stringify(this.DialogFormData.img_array);
        var specification_amount = [
          {
            specification: this.DialogFormData.specification,
            price: this.DialogFormData.price,
            unit: this.DialogFormData.unit,
          },
        ];
        var address = this.DialogFormData.address.join("/");

        if (this.Type == "Create") {
          this.axios
            .post(
              `/api/seller_quotation/`,
              Object.assign({}, this.DialogFormData, {
                img_array,
                specification_amount,
                address,
                // title,
              })
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        } else {
          this.axios
            .put(
              `/api/seller_quotation/${this.DialogFormData.code}/`,
              Object.assign({}, this.DialogFormData, {
                img_array,
                specification_amount,
                address,
                // title,
              })
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        }
      });
    },
  },
};
</script>


<style scoped lang="scss">
/deep/.el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}
.label_tip {
  color: $warningColor;
  position: absolute;
  right: 0;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  top: 2px;
}
</style>

